interface MessageTimestampProps {
  timestamp: number;
  isOutbound?: boolean;
}

export default function MessageTimestamp({
  timestamp,
  isOutbound,
}: MessageTimestampProps) {
  if (!timestamp) return null;

  return (
    <p
      className={`text-[1.5rem] text-brand-gray ${
        isOutbound ? 'mr-4' : 'mr-4 self-start'
      }`}
    >
      {new Date(timestamp).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })}
    </p>
  );
}
